import React from 'react';

import {AutosuggestItem, AutosuggestNoResults} from '@pb/kit-component-autosuggest-v2';

import {UserSuggestItem} from './user-suggest-item';

import type {UserSearchResponse} from 'src/openapi/admin/models/UserSearchResponse';
import type {UserSearchResult} from 'src/openapi/admin/models/UserSearchResult';
import type {ServerResponse} from 'src/typedef';

type Props = {
    id: string,
    selectedUsers: (UserSearchResult | string)[],
    response: ServerResponse<UserSearchResponse> | null,
};

export const UsersSuggestList = ({id, response, selectedUsers}: Props) => {
    if (!response) {
        return <AutosuggestNoResults id={id} strongText="Loading..." text=""/>;
    }

    if (response?.data?.result.length) {
        return (
            <div id={id}>
                {response.data.result.map(user => (
                    <AutosuggestItem
                        key={user.id}
                        value={user}
                        caption={<UserSuggestItem selectedUsers={selectedUsers} user={user}/>}
                    />
                ))}
            </div>
        );
    }

    if (response?.data && !response.data.result.length) {
        return <AutosuggestNoResults/>;
    }

    if (response?.error) {
        return <AutosuggestNoResults id={id} text={response.error.message} strongText=""/>;
    }

    return null;
};
